package net.zagart.ai.core.client

import kotlinx.serialization.Serializable

@Serializable
enum class AiChatRole {
    system,
    user,
    assistant
}
